import { createApp } from 'vue/dist/vue.esm-bundler';
import HpNews from './HpNews.vue';

const mountEl = document.querySelector('[data-app-hp-news-list]');

if ( mountEl )
{
    createApp(HpNews, { 
        ...mountEl.dataset 
    }).mount(mountEl);
}